
  import noneRuntime$Lrgjd3L6TcyV_A0XBUnlK2FDR6h7Szy7KW6v8PGskNk from '/home/snaumann/Development/public_html/firmenlauf-potsdam/public/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.9.3_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime$ewVlXQZe2vmJ1aImEhj_45aX9PfIZbN59_45bfkKcA_UvEc from '/home/snaumann/Development/public_html/firmenlauf-potsdam/api/vendors/gsmaterials/imgProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "gs",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"gs"} */
    provider: "gs",
    providers: {
        ['none']: { setup: noneRuntime$Lrgjd3L6TcyV_A0XBUnlK2FDR6h7Szy7KW6v8PGskNk, defaults: true },
  ['gs']: { setup: gsRuntime$ewVlXQZe2vmJ1aImEhj_45aX9PfIZbN59_45bfkKcA_UvEc, defaults: undefined }
    }
  }
